'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function hideTwitterMedia() {
        context.find('[data-binding="tweet-contain"]').find('.twitter-timeline').contents().find('.timeline-Tweet-media').css('display', 'none');

        context.find('[data-binding="tweet-contain"]').css('height', '100%');
    }

    function init() {

        context.find('[data-binding="tweet-contain"]').delegate('#twitter-widget-0', 'DOMSubtreeModified propertychange', function () {

            hideTwitterMedia();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/news-blog-social.js
// module id = 505
// module chunks = 0